<template lang="pug">
.d-flex.flex-column.fill-height
  v-img(
    class="white--text"
    gradient="to bottom, rgba(0,0,0,.3), rgba(0,0,0,.5)"
    :key="imgHeight"
    :max-height="imgHeight"
    :src="require('@/assets/directions-bg/art.jpg')"
  )
    v-card-title(ref="title") {{ item.title }}
  v-card-text(height="100%").overflow-auto.scroll
    tags-list(
      :value="tags"
      multiple
      :readOnly="readOnly"
      @input="handleTags"
    )
    | {{ item.description }}
  v-card-actions
    v-btn(
      v-if="routeProps.edit.name"
      fab small outlined color="primary" :to="routeProps.edit"
    ): v-icon() mdi-pencil
    v-spacer
    v-btn(
      color="primary" outlined
      target="_blank"
      :to="routeProps.view"
    ).pl-6 Перейти
      v-icon(right) mdi-chevron-right
</template>
<script>
import TagsList from '../TagsList.vue';

export default {
  components: {
    TagsList,
  },
  props: {
    item: { type: Object, required: true },
    readOnly: { type: Boolean, default: false },
  },
  data() {
    return {
      tags: this.item.tags ? this.item.tags.map(({ id }) => id) : [],
      imgHeight: null,

    };
  },
  computed: {
    isProgramType() {
      return Object.hasOwn(this.item, 'type');
    },
    routeProps() {
      return {
        edit: {
          name: this.isProgramType ? '' : 'ResourceDetailEdit',
          params: { id: this.item.id },
        },
        view: {
          name: this.item.course_id ? 'CourseView' : 'ResourceDetail',
          params: { id: this.isProgramType ? this.item.course_id : this.item.id },
        },
      };
    },
  },

  mounted() {
    const maxHeight = 90;
    const imgHeight = this.$refs?.title?.offsetHeight;
    this.imgHeight = imgHeight > maxHeight ? imgHeight : maxHeight;
  },
  methods: {
    handleTags(val) {
      const tags = [...val, ...this.tags].reduce((acc, value) => {
        if (!this.tags.includes(value)) acc.save.push(value);
        if (!val.includes(value)) acc.delete.push(value);
        return acc;
      }, { save: [], delete: [] });
      if (tags.save.length) this.attachTag(tags.save);
      if (tags.delete.length) this.detachTag(tags.delete);
      this.tags = val;
    },
    attachTag(tags) {
      const method = this.isProgramType ? 'programAttachTags' : 'practiceAttachTags';
      this.$api.mentoring[method](this.item.id, { tag_ids: tags });
    },
    detachTag(tags) {
      const method = this.isProgramType ? 'programDetachTags' : 'practiceDetachTags';
      this.$api.mentoring[method](this.item.id, { tag_ids: tags });
    },
  },
};
</script>
